import { validateAccessControlTable } from '../services';
import { validateAccessControl } from '../slice/accessControlSlice';
import { AccessControlState } from '../slice/initialStateGoalAccessMatrix';

export const validateAndUpdateAccessControl = async (
  tableData: {
    rolesToCreateConfig?: AccessControlState['accessControl']['rolesToCreateConfig'];
    rolesToViewUpdateStatusEditDeleteConfig?: AccessControlState['accessControl']['rolesToViewUpdateStatusEditDeleteConfig'];
    rolesToUploadInsightsCustomTagConfig?: AccessControlState['accessControl']['rolesToUploadInsightsCustomTagConfig'];
  },
  dispatch
) => {
  try {
    const res = (await validateAccessControlTable(tableData)) as AccessControlState['accessControl'];
    dispatch(
      validateAccessControl({
        ...res,
      })
    );
  } catch (error) {
    console.error('Error validating access control table', error);
  }
};
